var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center",staticStyle:{"height":"100vh"}},[_c('span',[_vm._v("404. Страница не найдена.")]),_c('router-link',{attrs:{"to":{ name: 'home.index'}}},[_vm._v("На главную?")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }